<input
  type="file"
  accept="{{
    uploadItem.photoType === PhotoType.ProPageFaviconEng ? 'image/*' : 'image/png, image/jpg, image/jpeg, image/gif'
  }}"
  style="display: none"
  (change)="selectFileHandler($event, uploadItem.photoType)"
  #fileInput
/>

<div class="upload-block" [ngClass]="{ 'upload-block--last-child': uploadItemIndex === uploadItemLength - 1 }">
  <div class="upload-block__header">
    <h5 class="upload-block__header-title">{{ uploadItem.title }}</h5>
    <div class="btv-icon-delete" (click)="deleteHandler(uploadItem.photoType)"></div>
  </div>

  <div class="upload-block__content" (click)="fileInput.click()">
    <img [src]="'assets/images/icons/upload-icon.svg' | bmAssetUrl" alt="upload-bg" />
    <p>{{ lg.colorCustomizer.uploadImagesBlock.selectFileDescr }}</p>
  </div>

  <p class="upload-block__helper">{{ uploadItem.helper }}</p>

  @if (uploadImageResult.status !== 'idle') {
    <bmcore-upload-progr-bar [uploadImageResult]="uploadImageResult" [file]="file"> </bmcore-upload-progr-bar>
  }
</div>
